import { Component, OnInit, Inject } from '@angular/core';
import { MgService } from 'src/app/services/mg.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Call } from 'src/app/models/call.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-open-os-dialog',
  templateUrl: './open-os-dialog.component.html',
  styleUrls: ['./open-os-dialog.component.scss']
})
export class OpenOsDialogComponent implements OnInit {
  public entryEditor = ClassicEditor;

  public technician: number;
  public description: string = "";
  public saving: boolean = false;
  public users: User[];

  public os: any;

  constructor(
    private api: MgService,
    public dialogRef: MatDialogRef<OpenOsDialogComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { call: Call }
  ) { }

  ngOnInit(): void {
    this.listOperators()
  }

  private listOperators() {
    // this.users
    this.api.listUser()
      .subscribe(
        res => {
          this.users = res.data
        },
      )
  }

  public copyCallText() {
    this.description = this.data.call.description
  }

  public createOs() {
    this.saving = true
    this.api.createOs({
      business: { id: this.data.call.business_id },
      call: this.data.call.id,
      description: this.description,
      technician: this.technician
    })
      .subscribe(
        res => {
          this.os = res.data
          this.snackBar.open(
            `OS aberta: #${ this.os.number }`,
            'OK',
            {
              duration: 2000,
            }
          );
        },
        err => this.saving = false,
        () => this.saving = false
      )
  }

}
